<div class="login-container">
      <div class="login-container__background"></div>
      <div class="login-container__content">
        <div class="login-container__content__logo"></div>
        <div class="login-container__content__section">
            <div class="login-container__content__section__title">{{ 'login.title' | transloco }}</div>
            <div class="login-container__content__section__divider"></div>
            <div class="login-container__content__section__subtitle">{{ 'login.subtitle' | transloco }}</div>
        </div>
    </div>
    <div class="login-container__form-container">        
        <!-- Login Form -->
        <form class="login-container__form-container__form" (ngSubmit)="login()" #loginForm="ngForm">
          <!-- Username Field -->
           
        <div class="input-container" [ngClass]="{'has-value': username}">
          <input
              id="username"
              type="text"
              [(ngModel)]="username"
              placeholder="{{ 'login.username' | transloco }}"
              name="username"
              class="input"
              required
          />
        </div>
      
          <!-- Password Field -->
        <div class="input-container" [ngClass]="{'has-value': password}">
          <input
              id="password"
              [type]="showPassword ? 'text' : 'password'"
              [(ngModel)]="password"
              placeholder="{{ 'login.password' | transloco }}"
              name="password"
              class="input"
              required
          />
          <div class="input-container__img" (click)="togglePassword()">
            <img src="../../../assets/icons/eye-slash.svg" [ngClass]="{'inactive': showPassword }">
          </div>
        </div>
      
          <!-- Error Message -->
          <div class="login-container__form-container__form__error" *ngIf="errorMessageKey">
            {{ errorMessageKey | transloco }}
          </div>
      
          <!-- Submit Button -->
          <button type="submit" class="btn btn-primary" [disabled]="!loginForm.valid">
            {{ 'login.login-button' | transloco }}
          </button>
        </form>
    </div>
  </div>
